import { StreamingPageItemApiModel } from '@cxb/content-stb-api';
import { LocalizedStringApiModel } from '@cxb/content-stb-api/model/localizedStringApiModel';
import { Entity } from '@nx-data/nx-data';

export class PageItemEntity extends Entity implements StreamingPageItemApiModel {
  public title: string;
  public titleLocalized: LocalizedStringApiModel;
  public slug: string;
}
